import { ApolloProvider } from "@apollo/client";
import { datadogLogs } from "@datadog/browser-logs";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

/** FIXME: redux - deprecate createStore 대신 Redux Toolkit configureStore 사용 */
import { legacy_createStore as createStore } from "redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import { PROD_DOMAIN } from "@const/urls";

import App from "./App";
import client from "./lib/apollo";
import { persistedReducer } from "./reducers";

// PROD 환경일 때 만 로깅
if (window.location.href.includes(PROD_DOMAIN)) {
  // Datadog 로그 초기화
  datadogLogs.init({
    clientToken: import.meta.env.VITE_REACT_DATA_DOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "tune",
    env: "prod",
    forwardErrorsToLogs: true, // 에러 자동 로깅
    forwardConsoleLogs: "all",
    sessionSampleRate: 100, // 로그 샘플링 비율
    version: "v1.0.0",
  });
}

const store = createStore(persistedReducer);
const persistor = persistStore(store);

if (window.location.pathname === "/refresh") {
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
}

const root = createRoot(document.getElementById("root")!);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </PersistGate>
  </Provider>,
);
